function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGenset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 82 82",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Layer_3",
    "data-name": "Layer 3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M69.59,43c0,.17,0,.34,0,.51v0c0,.21,0,.42,0,.63v.1c0,.19,0,.37,0,.55s0,.12,0,.18l-.06.48c0,.08,0,.16,0,.24l-.06.42c0,.1,0,.2,0,.29l-.06.37c0,.12,0,.23,0,.35l-.06.31c0,.13-.05.26-.07.39l-.06.27-.09.43a1.89,1.89,0,0,0-.05.23l-.12.46c0,.07,0,.13,0,.19l-.14.5a.83.83,0,0,1,0,.15l-.15.53,0,.12c-.06.19-.11.37-.18.56l0,.08c-.07.2-.14.39-.2.59l0,0c-.08.2-.15.41-.23.61v0A29.42,29.42,0,0,1,43.09,71.34l-2.8-3.62,2.58-4.56A21.2,21.2,0,0,0,50,60.9h0l.21-.12.15-.08.48-.27.11-.07.5-.3.08,0,.53-.35,0,0c.19-.13.37-.25.55-.39h0a21.23,21.23,0,0,0,8.72-16.13",
    style: {
      fill: "none",
      strokeWidth: "1.5px",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.27,71.47l-.51,0h0l-.63,0H38l-.55,0h-.18l-.48-.06-.24,0-.42-.06-.29,0-.37-.06-.34,0L34.82,71l-.39-.07-.27-.06-.43-.09-.23,0L33,70.61l-.19,0-.5-.14-.15,0-.53-.15-.12,0L31,70l-.08,0-.59-.2-.05,0-.61-.23h0A29.42,29.42,0,0,1,10.9,45l3.62-2.8,4.56,2.58a21.2,21.2,0,0,0,2.26,7.16h0l.12.21.08.15.27.48.07.11.3.5,0,.08c.12.18.23.36.35.53l0,0,.39.55h0A21.23,21.23,0,0,0,39.12,63.3",
    style: {
      fill: "none",
      strokeWidth: "1.5px",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.77,41.15h0c0-.17,0-.34,0-.51v0c0-.21,0-.42,0-.63v-.1c0-.19,0-.37.05-.55a1.1,1.1,0,0,1,0-.18c0-.16,0-.32,0-.48s0-.16,0-.24L11,38c0-.1,0-.2,0-.29l.06-.37c0-.12,0-.23,0-.34l.06-.32c0-.13,0-.26.08-.39a2.56,2.56,0,0,1,0-.27l.09-.43.06-.23c0-.15.07-.31.11-.46s0-.13,0-.19l.14-.5s0-.1,0-.15l.15-.53,0-.12.18-.56,0-.08c.07-.2.14-.39.2-.59l0-.05c.08-.2.15-.41.23-.61v0A29.42,29.42,0,0,1,37.27,12.78l2.8,3.62L37.49,21a21.2,21.2,0,0,0-7.16,2.26h0l-.21.12-.15.08-.48.27-.11.07c-.17.1-.34.2-.5.31l-.08,0-.53.35,0,0-.55.39h0A21.23,21.23,0,0,0,18.94,41",
    style: {
      fill: "none",
      strokeWidth: "1.5px",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.09,12.65l.51,0h0l.63,0h.1l.55,0,.18,0,.48.05.24,0,.42.06.29,0,.37.06.35.05.31.06.39.08.27.05.43.09.23.06.46.11.19,0,.5.14.15,0,.53.15.12,0,.56.18.08,0,.59.2.05,0,.61.23h0A29.42,29.42,0,0,1,69.46,39.15L65.84,42l-4.56-2.58A21.2,21.2,0,0,0,59,32.21h0L58.91,32l-.08-.15-.27-.48-.07-.11-.3-.5,0-.08c-.12-.18-.23-.36-.35-.53l0,0c-.13-.19-.25-.37-.39-.55h0a21.23,21.23,0,0,0-16.13-8.72",
    style: {
      fill: "none",
      strokeWidth: "1.5px",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "41.55 17.05 47.81 18.09 46.42 24.13 44.28 25.39 41.55 17.05",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "39.33 10.07 49.29 11.93 47.66 18.79 42.06 18.41 39.33 10.07",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "29.33 72.09 33.98 58.6 41.09 71.47 39.25 75.24 29.33 72.09",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "37.3 57.86 42.46 61.56 38.55 66.37 36.08 66.55 37.3 57.86",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.28 10.07 26.62 45.35 41.21 45.35 31.02 74.26 57.1 38.35 41.09 38.35 47.28 10.07",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      strokeWidth: 2
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "47.28 10.07 26.62 45.33 41.03 45.33 31.02 74.26 57.1 38.39 41.1 38.39 47.28 10.07",
    style: {
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      fill: "#fff",
      strokeWidth: 2
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGenset);
export default __webpack_public_path__ + "static/media/genset.c3d000a7fdc7b85a6e01bd6edc8c036e.svg";
export { ForwardRef as ReactComponent };